module.exports = __webpack_public_path__ + "img/test-mode10.d0f34f28.png";